/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiClassificationRulePeriodTypeFromJSON, ApiClassificationRulePeriodTypeToJSON, } from './ApiClassificationRulePeriodType';
import { ApiClassificationVariableFromJSON, ApiClassificationVariableToJSON, } from './ApiClassificationVariable';
import { ApiOperatorFromJSON, ApiOperatorToJSON, } from './ApiOperator';
export function ApiClassificationRulePayloadFromJSON(json) {
    return ApiClassificationRulePayloadFromJSONTyped(json, false);
}
export function ApiClassificationRulePayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'conversionId': !exists(json, 'conversionId') ? undefined : json['conversionId'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'leadStatusId': !exists(json, 'leadStatusId') ? undefined : json['leadStatusId'],
        'locationId': !exists(json, 'locationId') ? undefined : json['locationId'],
        'locationPageTaggerId': !exists(json, 'locationPageTaggerId') ? undefined : json['locationPageTaggerId'],
        'oldCondition': !exists(json, 'oldCondition') ? undefined : json['oldCondition'],
        'operator': !exists(json, 'operator') ? undefined : ApiOperatorFromJSON(json['operator']),
        'pageTagValue': !exists(json, 'pageTagValue') ? undefined : json['pageTagValue'],
        'period': !exists(json, 'period') ? undefined : json['period'],
        'periodType': !exists(json, 'periodType') ? undefined : ApiClassificationRulePeriodTypeFromJSON(json['periodType']),
        'productId': !exists(json, 'productId') ? undefined : json['productId'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'variable': !exists(json, 'variable') ? undefined : ApiClassificationVariableFromJSON(json['variable']),
    };
}
export function ApiClassificationRulePayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'conversionId': value.conversionId,
        'key': value.key,
        'leadStatusId': value.leadStatusId,
        'locationId': value.locationId,
        'locationPageTaggerId': value.locationPageTaggerId,
        'oldCondition': value.oldCondition,
        'operator': ApiOperatorToJSON(value.operator),
        'pageTagValue': value.pageTagValue,
        'period': value.period,
        'periodType': ApiClassificationRulePeriodTypeToJSON(value.periodType),
        'productId': value.productId,
        'value': value.value,
        'variable': ApiClassificationVariableToJSON(value.variable),
    };
}
